import { ReactNode } from "react";
import { ReactComponent as BoltIcon } from "../assets/bolt.svg";
import { ReactComponent as WeldIcon } from "../assets/weld.svg";
import { ReactComponent as AnchorIcon } from "../assets/anchor.svg";
import { ReactComponent as EndplateIcon } from "../assets/end-plate.svg";
import { ReactComponent as FinplateIcon } from "../assets/fin-plate.svg";
import { ReactComponent as CleatIcon } from "../assets/Union.svg";
import { ReactComponent as SpliceIcon } from "../assets/splice.svg";
import { ReactComponent as MyBookmarksIcon } from "../assets/my-bookmarks.svg";
import { ReactComponent as OthersBookmarksIcon } from "../assets/others-bookmarks.svg";
import { FeatureClauses, FilterTypes, PopularityFilters } from "../types/CDIFilter";

export interface FilterItemConfig {
	name: string;
	defaultMessage: string;
	feature: string;
	icon: ReactNode;
	filterType: FilterTypes;
}

export interface FilterGroupConfig {
	title: string;
	titleMessageId: string;
	filterType: FilterTypes;
	items: FilterItemConfig[];
}

export interface PopularityFilterItemConfig {
	name: string;
	defaultMessage: string;
	feature: keyof PopularityFilters;
	icon: ReactNode;
	filterType: FilterTypes;
}

export interface DesignCodeOption {
	value: string;
	label: string;
}

export const DESIGN_CODE_OPTIONS: DesignCodeOption[] = [
	{ value: "all", label: "All" },
	{ value: "ECEN", label: "EN" },
	{ value: "American", label: "AISC" },
	{ value: "Canada", label: "CSA" },
	{ value: "AUS", label: "AS" },
	{ value: "CHN", label: "GB" },
	{ value: "India", label: "IS" },
	{ value: "HKG", label: "HKG" },
];

export const INITIAL_CONNECTOR_FILTERS = [
	{ feature: "bolt", clause: 0 },
	{ feature: "weld", clause: 0 },
];

export const INITIAL_FEATURE_FILTERS = [
	{ feature: "anchoring", clause: 0 },
	{ feature: "cleat", clause: 0 },
	{ feature: "spliceplate", clause: 0 },
	{ feature: "group_endplate", clause: 0 },
	{ feature: "group_finplate", clause: 0 },
];

export const INITIAL_POPULARITY_FILTERS: PopularityFilters = {
	MyBookmarks: FeatureClauses.None,
	OthersBookmarks: FeatureClauses.None,
};

export const POPULARITY_FILTER_ITEMS: PopularityFilterItemConfig[] = [
	{
		name: "OthersBookmarks",
		defaultMessage: "Other's bookmarks",
		feature: "OthersBookmarks",
		icon: <OthersBookmarksIcon />,
		filterType: "popularity",
	},
	{
		name: "MyBookmarks",
		defaultMessage: "My bookmarks",
		feature: "MyBookmarks",
		icon: <MyBookmarksIcon />,
		filterType: "popularity",
	},
];

export const FILTER_GROUPS = {
	connectors: {
		title: "Connectors",
		titleMessageId: "Connectors",
		filterType: "connector" as FilterTypes,
		items: [
			{
				name: "Bolt",
				defaultMessage: "Bolt",
				feature: "bolt",
				icon: <BoltIcon />,
				filterType: "connector" as FilterTypes,
			},
			{
				name: "Weld",
				defaultMessage: "Weld",
				feature: "weld",
				icon: <WeldIcon />,
				filterType: "connector" as FilterTypes,
			},
		],
	} as FilterGroupConfig,
	
	features: {
		title: "Features",
		titleMessageId: "Features",
		filterType: "feature" as FilterTypes,
		items: [
			{
				name: "Anchor",
				defaultMessage: "Anchor",
				feature: "anchoring",
				icon: <AnchorIcon />,
				filterType: "feature" as FilterTypes,
			},
			{
				name: "Endplate",
				defaultMessage: "End plate",
				feature: "group_endplate",
				icon: <EndplateIcon />,
				filterType: "feature" as FilterTypes,
			},
			{
				name: "FinPlate",
				defaultMessage: "Fin plate",
				feature: "group_finplate",
				icon: <FinplateIcon />,
				filterType: "feature" as FilterTypes,
			},
			{
				name: "Cleat",
				defaultMessage: "Cleat",
				feature: "cleat",
				icon: <CleatIcon />,
				filterType: "feature" as FilterTypes,
			},
			{
				name: "Splice",
				defaultMessage: "Splice",
				feature: "spliceplate",
				icon: <SpliceIcon />,
				filterType: "feature" as FilterTypes,
			},
		],
	} as FilterGroupConfig,
	
	popularity: {
		title: "Popularity",
		titleMessageId: "Popularity",
		filterType: "popularity" as FilterTypes,
		items: POPULARITY_FILTER_ITEMS as unknown as FilterItemConfig[],
	} as FilterGroupConfig,
};